import React from "react";
import { marked } from "marked";
import DOMPurify from "dompurify";
import PropTypes from "prop-types";
import {
  CardWrapper,
  Row,
  Column,
  Title,
  Text,
  CollapsibleLink,
} from "./styles/job-description-styles";

class AgencyBriefing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
    };
  }

  onCollapseClick = () => {
    this.setState(({ isExpanded }) => ({
      isExpanded: !isExpanded,
    }));
  };

  render() {
    const { agencyBriefing } = this.props;
    const { isExpanded } = this.state;
    const rawMarkup = marked(DOMPurify.sanitize(agencyBriefing));
    return (
      <CardWrapper>
        <Row>
          <Column className={isExpanded ? "expanded" : ""} collapsibleType isExpanded={isExpanded}>
            <Title>Agency Briefing</Title>
            <Text dangerouslySetInnerHTML={{ __html: rawMarkup }} />
            {agencyBriefing.length > 150 && (
              <CollapsibleLink onClick={this.onCollapseClick}>
                {isExpanded ? "show less" : "read more"}
              </CollapsibleLink>
            )}
          </Column>
        </Row>
      </CardWrapper>
    );
  }
}

AgencyBriefing.propTypes = {
  agencyBriefing: PropTypes.string.isRequired,
};

export default AgencyBriefing;
